"use client";

import { useEffect, useRef, useState } from "react";

import toast from "@/lib/toast";
import { t } from "@/lib/localization";

export const useCopyToClipboard = () => {
    const [copied, setCopied] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const copy = async (text: string) => {
        if (copied) return;
        try {
            await navigator.clipboard.writeText(text);
        } catch {
            toast.error(t("toast.error.copy-failed"), {
                keyName: "toast.error.copy-failed",
            });
            return;
        }
        setCopied(true);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setCopied(false), 2000);
    };

    return { copied, copy };
};
